const nodes = [
  { x: 300, y: 170, r: 4 },
  { x: 274, y: 96, r: 3.5 },
  { x: 274, y: 244, r: 3.5 },
  { x: 232, y: 52, r: 2.5, faint: true },
  { x: 232, y: 288, r: 2.5, faint: true },
  { x: 318, y: 130, r: 2.5, faint: true },
  { x: 318, y: 210, r: 2.5, faint: true },
];

const chaos = [
  [44, 70], [26, 150], [58, 214], [40, 270], [88, 110], [70, 300],
];

const ReliabilityCore = () => {
  return (
    <div className="relative aspect-square w-full max-w-[340px] mx-auto select-none">
      {/* ambient core glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-40 h-40 bg-accent/15 blur-[70px] rounded-full" />
      </div>

      <svg viewBox="0 0 340 340" className="relative w-full h-full overflow-visible" fill="none">
        <defs>
          <radialGradient id="rc-core" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="hsl(var(--accent))" stopOpacity="0.85" />
            <stop offset="100%" stopColor="hsl(var(--accent))" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* chaotic failure field resolving toward the core */}
        <g className="rc-chaos">
          {chaos.map(([x, y], i) => (
            <g key={i}>
              <line x1={x} y1={y} x2={170} y2={170} stroke="hsl(var(--destructive))" strokeOpacity="0.12" strokeWidth="1" strokeDasharray="3 5" />
              <circle cx={x} cy={y} r="2.5" fill="hsl(var(--destructive))" fillOpacity="0.4" />
            </g>
          ))}
        </g>

        {/* ordered engineered lattice */}
        <g>
          {nodes.map((n, i) => (
            <line key={i} x1="170" y1="170" x2={n.x} y2={n.y} stroke="hsl(var(--accent))" strokeOpacity={n.faint ? 0.25 : 0.55} strokeWidth={n.faint ? 1 : 1.4} />
          ))}
        </g>
        <g fill="hsl(var(--accent))">
          {nodes.map((n, i) => (
            <circle key={i} cx={n.x} cy={n.y} r={n.r} fillOpacity={n.faint ? 0.55 : 1} />
          ))}
        </g>

        {/* concentric orbit rings */}
        <g className="rc-spin-slow" style={{ transformOrigin: "170px 170px" }}>
          <circle cx="170" cy="170" r="100" stroke="hsl(var(--accent))" strokeOpacity="0.1" strokeWidth="1" strokeDasharray="4 8" />
        </g>
        <g className="rc-spin-rev" style={{ transformOrigin: "170px 170px" }}>
          <circle cx="170" cy="170" r="72" stroke="hsl(var(--primary))" strokeOpacity="0.4" strokeWidth="1.25" strokeDasharray="46 200" />
          <circle cx="242" cy="170" r="3" fill="hsl(var(--accent))" />
        </g>

        {/* core halo */}
        <circle cx="170" cy="170" r="50" fill="url(#rc-core)" />

        {/* engineered core diamond (centered over glow) */}
        <g transform="rotate(45 170 170)">
          <rect x="148" y="148" width="44" height="44" stroke="hsl(var(--accent))" strokeWidth="2" />
          <rect x="158" y="158" width="24" height="24" stroke="hsl(var(--accent))" strokeWidth="1" strokeOpacity="0.5" className="rc-pulse" />
          <rect x="166" y="166" width="8" height="8" fill="hsl(var(--accent))" className="rc-pulse" />
        </g>
      </svg>
    </div>
  );
};

export default ReliabilityCore;
